import moment from "moment";
const initialFilterObj = {
  search: "",
  page: 1,
  limit: process.env.REACT_APP_PAGE_LIMIT,
  sorted: {
    value: { column: "available", order: "asc" },
    label: "Available (Ascending)",
  },
  start_date: moment().startOf("month"),
  end_date: moment().endOf("month"),
};

// **  Initial State
const initialState = {
  data: [],
  start: 0,
  end: 0,
  totalRecords: 0,
  totalPages: 0,
  percentage: 0,
  currentPage: 1,
  params: {},
  loading: true,
  filter: initialFilterObj,
};

const openingClosingReport = (state = initialState, action) => {
  switch (action.type) {
    case "GET_OPENING_CLOSING_REPORT":
      console.log("action.payload--->4", action.payload);
      return {
        ...state,
        data: action.payload.raw_material_list,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        currentPage: action.payload.page,
        params: { limit: action.payload.limit, page: action.payload.page },
        loading: false,
      };

    case "INVENTORY_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    case "SET_FILTER":
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
          page: action.payload.page ? action.payload.page : 1,
        },
      };
    case "RESET_FILTER":
      return {
        ...state,
        filter: { ...initialFilterObj },
      };
    default:
      return state;
  }
};

export default openingClosingReport;
